import { createSlice } from "@reduxjs/toolkit";

import { Staff } from "@/interfaces/IAuth";

interface userInterface {
  isLoggedIn: boolean;
  user: Staff | Record<string, never>;
  error: any;
  token: string | null;
}

const initialState: userInterface = {
  isLoggedIn: false,
  user: {},
  error: null,
  token: null,
};

export const userReducer = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload.user;

      state.token = action.payload.token;
      state.isLoggedIn = !!action.payload.token;
    },
    logout: (state) => {
      state = initialState;
      return state;
    },
    setProfile: (state, action) => {
      // state.user = action.payload;
      state.user = { ...state.user, ...action.payload };

      // state.user = { ...state.user, avatar: action.payload.avatar };
    },
  },
});

export const { setUser, logout, setProfile } = userReducer.actions;

export default userReducer.reducer;
